(() => {
  const cache = new Map();
  const fill = async (el) => {
    const name = (el.getAttribute("data-lucide-name") || "").trim().toLowerCase();
    if (!/^[a-z0-9-]+$/.test(name) || el.dataset.lucideReady === name) return;
    if (!cache.has(name)) {
      cache.set(
        name,
        fetch(`https://cdn.jsdelivr.net/npm/lucide-static@0.544.0/icons/${name}.svg`)
          .then((res) => (res.ok ? res.text() : ""))
          .catch(() => "")
      );
    }
    const svg = await cache.get(name);
    if (!svg) return;
    el.innerHTML = svg;
    el.querySelector("svg")?.setAttribute("stroke-width", "1.5");
    el.dataset.lucideReady = name;
  };
  const scan = (root = document) => {
    root.querySelectorAll("[data-lucide-name]").forEach((el) => {
      fill(el);
    });
  };
  scan();
  document.addEventListener("shopify:section:load", (event) => scan(event.target));
})();
